<template>
    <i class="suspended_ball el-icon-service" :class="isMove ? '' : 'animation'" @mousedown="mousedown"
        @mouseup="mouseup" @mouseleave="mouseup" @mousemove="onMoveBall" @touchstart="isMove = true"
        @touchend="isMove = false" @touchmove="onMoveBall" @click="onClickBall" :style="style"></i>
</template>
<script>
export default {
    name: 'SuspendedBall',
    props: {

    },
    emits: ['clickBall'],
    data() {
        return {
            style: {
                "--left": 'calc(100% - 30px)',
                "--top": '50%'
            },
            clientX: window.document.body.offsetWidth,
            isMove: false,
            downTime: 0,
            upTime: 0,
            isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
            screenWidth: window.document.body.offsetWidth,
        };
    },
    computed: {},
    watch: {
        isMove(newVal) {
            if (newVal) return
            this.moveEnd()
        }
    },
    created() { },
    mounted() { },
    methods: {
        mousedown() {
            this.isMove = true
            this.downTime = Date.now()
        },
        mouseup() {
            this.isMove = false
            this.upTime = Date.now()
        },
        onMoveBall(event) {
            if (!this.isMove) return

            let clientX, clientY
            if (this.isMobile) {
                clientX = event.touches[0].clientX
                clientY = event.touches[0].clientY
            } else {
                clientX = event.clientX
                clientY = event.clientY
            }
            this.$set(this, 'style', {
                "--left": `${clientX}px`,
                "--top": `${clientY}px`
            })
            this.$set(this, 'clientX', clientX)
        },
        moveEnd() {
            if (this.clientX > this.screenWidth / 2) {
                this.style['--left'] = 'calc(100% - 30px)'
            } else this.style['--left'] = '30px'
        },
        onClickBall(event) {
            const time = this.upTime - this.downTime
            if (time > 300) return
            this.$emit('clickBall')
        }
    }
}
</script>
<style lang="scss">
.suspended_ball {
    font-size: 30px !important;
    color: #fff;
    background: #409EFF;
    padding: 8px !important;
    box-shadow: 0px 0px 4px 2px #409EFF;
    border-radius: 50%;
    border: none !important;
    position: absolute;
    left: var(--left);
    top: var(--top);
    transform: translate(-50%, -50%);
    z-index: 99;

    &.animation {
        transition: left .3s ease-in-out
    }
}
</style>